import React from "react";
import { Box, Typography, Paper } from "@mui/material";

export default function TermsConditions() {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #fff3e0 0%, #ffe0b2 100%)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: "10vw",
        pb: 8,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          width: "80%",
          maxWidth: "900px",
          borderRadius: "20px",
          backgroundColor: "rgba(255,255,255,0.9)",
          backdropFilter: "blur(8px)",
          boxShadow: "0px 10px 25px rgba(255, 102, 0, 0.2)",
        }}
      >
        <Typography variant="h3" sx={{ textAlign: "center", fontWeight: 800, color: "#ff6600", mb: 4 }}>
          Terms & Conditions
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          By using <strong>https://cosmicalcalculator.com</strong>, you agree to these
          Terms & Conditions. Please review them carefully before using our services.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          <strong>1. Service Use:</strong> All content provided is for informational and
          entertainment purposes. Cosmical Calculator is not responsible for personal
          outcomes derived from astrological guidance.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          <strong>2. Intellectual Property:</strong> Content, graphics, and design belong
          to Cosmical Calculator. Duplication or distribution without written consent is
          prohibited.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500, mb: 2 }}>
          <strong>3. Payments & Refunds:</strong> Payments made via PayU are subject to our
          Refund Policy. We reserve the right to modify or terminate any service anytime.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "1.15rem", fontWeight: 500 }}>
          <strong>4. Governing Law:</strong> These Terms shall be governed by the laws of
          India and the jurisdiction of Himachal Pradesh courts.
        </Typography>
      </Paper>
    </Box>
  );
}
